import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { Checkbox } from "primereact/checkbox";
import { getPaymentMode, postPaymentMode } from "../../../services/paymentMode/paymentMode";
import { MultiSelect } from "primereact/multiselect";

const PaymentModeCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
  const [gatewayNameData, setGatewayNameData] = useState([]);

  const [paymentModeList, setPaymentModeList] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState([]);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [selectedPaymentModeList, setSelectedPaymentModeList] = useState([]);
  const [selectedPaymentModeSubscriptionList, setSelectedPaymentModeSubscriptionList] = useState([]);
  const [selectedLocationPaymentMode1, setSelectedLocationPaymentMode1] = useState([])
  const [selectedLocationPaymentMode2, setSelectedLocationPaymentMode2] = useState([])
  const [selectedLocationPaymentMode3, setSelectedLocationPaymentMode3] = useState([])
  const [selectedLocationPaymentMode4, setSelectedLocationPaymentMode4] = useState([])

  const fetchPaymentMode = () => {
    getPaymentMode()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setPaymentModeList(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };



  useEffect(() => {
    fetchPaymentMode();

    if (item) {
      setSelectedPaymentMode(item?.paymentModes)
      setSelectedPaymentModeList(
        item?.paymentModes.map((item, index) => ({
          name: item,
          value: item
        })))
      setSelectedPaymentModeSubscriptionList(
         item?.paymentModes.filter((item) => item !== "USER_ACCOUNT").map((item, index) => ({
          name: item,
          value: item
        })))
      setSelectedLocationPaymentMode1(item?.paymentModeList?.Location1)
      setSelectedLocationPaymentMode2(item?.paymentModeList?.Location2)
      setSelectedLocationPaymentMode3(item?.paymentModeList?.Location3)
    }

  }, []);

  const handlePaymentModeSelectionToggle = (status) => {
    const updatedStatus = [...selectedPaymentMode];


    if (updatedStatus.includes(status)) {
      // Remove status if already selected
      updatedStatus.splice(updatedStatus.indexOf(status), 1);
    } else {
      // Add status if not selected
      updatedStatus.push(status);
    }


    setSelectedPaymentMode(updatedStatus);
    setSelectedPaymentModeList(updatedStatus.map((item, index) => ({
      name: item,
      value: item
    })))
    const filterData = updatedStatus.filter((item) => item !== "USER_ACCOUNT")
    setSelectedPaymentModeSubscriptionList(filterData.map((item, index) => ({
      name: item,
      value: item
    })))
  };


  const handleLocationPaymentMode1 = (item) => {
    setSelectedLocationPaymentMode1(item)
  }
  const handleLocationPaymentMode2 = (item) => {
    setSelectedLocationPaymentMode2(item)
  }
  const handleLocationPaymentMode3 = (item) => {
    setSelectedLocationPaymentMode3(item)
  }
  const handleLocationPaymentMode4 = (item) => {
    setSelectedLocationPaymentMode4(item)
  }

  const getCommonPaymentModes = (locationPaymentModes) => {
    const arr1 = selectedPaymentModeList.map(item => item.value);
    const arr2 = locationPaymentModes;

    const set2 = new Set(arr2);

    return arr1.filter(item => set2.has(item));
  };


  const handleSubmit = () => {
    // Reset all previous errors


    let isValid = true;
    if (selectedPaymentMode.length === 0) {
      setPaymentModeError("Please Select Payment Mode");
      isValid = false;
    }


    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        // Call the service function for creating pickup request

        const location1Common = getCommonPaymentModes(selectedLocationPaymentMode1);
        const location2Common = getCommonPaymentModes(selectedLocationPaymentMode2);
        const location3Common = getCommonPaymentModes(selectedLocationPaymentMode3);
        // const location4Common = getCommonPaymentModes(selectedLocationPaymentMode4);

        const data = {
          brandId: brandId,
          paymentModes: selectedPaymentMode.join(","),

          paymentModeList: {
            Location1: location1Common.join(","),
            Location2: location2Common.join(","),
            Location3: location3Common.join(","),
            // Location4: location4Common.join(","),
          }
        };

        postPaymentMode(data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                  setTimeout(() => {
                    navigate("/PaymentMode");
                  }, 1500);
                  setIsButtonPressed(false);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                  setIsButtonPressed(false);
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    } else {
      setIsButtonPressed(false);
    }
  };


  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/PaymentMode")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Payment Mode {item ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          {paymentModeList?.map((item) => (
            <div
              key={item.id}
              className="flex flex-1 justify-content-between my-1 px-2"
              style={{ backgroundColor: selectedPaymentMode.includes(item) ? "#1752AA" : null, borderRadius:30}}
            >
              {/* <p className="text-xl font-medium">{item.name}</p> */}
              <p className="text-xl font-medium" style={{ color: selectedPaymentMode.includes(item) ? "#fff" : "#000"}}>{item}</p>
              <div className="flex justify-content-center align-items-center">
                <Checkbox
                  checked={selectedPaymentMode.includes(item)}
                  size="20" // Increased size
                  color={
                    selectedPaymentMode.includes(item) ? "#00A3FF" : "#C1C9D3"
                  }
                  onClick={() => handlePaymentModeSelectionToggle(item)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex-1 mb-3">

          <div className="flex flex-1 mb-3">
            <div className="mx-4 mt-4 flex-1">

              <div

                className="flex flex-1 justify-content-between my-1"
              >
                <p className="text-xl font-medium">Orders</p>
                <div>
                  <div className="row">
                    <MultiSelect
                      display="chip"
                      value={selectedLocationPaymentMode1}
                      options={selectedPaymentModeList}
                      optionLabel="name"
                      onChange={(e) => handleLocationPaymentMode1(e.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-1 mb-3">
            <div className="mx-4 mt-4 flex-1">

              <div

                className="flex flex-1 justify-content-between my-1"
              >
                <p className="text-xl font-medium">Subscription</p>
                <div>
                  <div className="row">
                    <MultiSelect
                      display="chip"
                      value={selectedLocationPaymentMode2}
                    options={selectedPaymentModeSubscriptionList}
                      optionLabel="name"
                      onChange={(e) => handleLocationPaymentMode2(e.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-1 mb-3">
            <div className="mx-4 mt-4 flex-1">

              <div

                className="flex flex-1 justify-content-between my-1"
              >
                <p className="text-xl font-medium">Store Rider</p>
                <div>
                  <div className="row">
                    <MultiSelect
                      display="chip"
                      value={selectedLocationPaymentMode3}
                      options={selectedPaymentModeList}
                      optionLabel="name"
                      onChange={(e) => handleLocationPaymentMode3(e.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="mx-4 my-2">
        {paymentModeError && (
          <p className="text-lg font-normal" style={{ color: "red" }}>
            {paymentModeError}
          </p>
        )}
      </div>

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PaymentModeCreate;
